import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function BackgroundIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 14 14"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M6.586 0L0 6.586V9.414L9.414 0H6.586Z" />
        <path d="M0 0V3.414L3.414 0H0Z" />
        <path d="M10.586 14H14V10.586L10.586 14Z" />
        <path d="M14 0H12.586L0 12.586V14H1.414L14 1.414V0Z" />
        <path d="M14 4.586L4.586 14H7.414L14 7.414V4.586Z" />
      </svg>
    </Icon>
  );
}
